import ValueSelector from '@nile/banyan/src/Components/Controls/ValueSelector';
import { TicketClient, GET_FIELD, AccountClient } from '@nile/graphql';
import {
  ActionElement,
  ActionGroupElement,
  getTranslatedText,
  ALL_MODULES,
  ENTITY_MAP,
  getEntityAttributes
} from '@nile/components';
import ValueEditor from '@nile/banyan/src/Components/Controls/ValueEditor';
import { HeaderTag } from '@nile/components/src';
import { apiMethodAndKeyNames, apiResolver } from '@nile/graphql';
import _, { cloneDeep } from 'lodash';
import nanoid from 'nanoid';
import React, { useState, useEffect } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import styled from 'styled-components';
import { SVGIcon } from '@superops/super-icons';

class PropertySelection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      conditions: this.props.propertyConditions || []
    };
  }

  componentWillReceiveProps(nextProps) {
    if (!_.isEqual(nextProps.propertyConditions, this.state.conditions)) {
      this.setState({ conditions: nextProps.propertyConditions });
    }
  }

  getValueEditorType = (item) => {
    if (item.name === 'client') {
      return 'dependant';
    }
    switch (item.dataType) {
      default:
        return item.uiDataType;
    }
  };

  getParentLabel = (item) => {
    const { allFields } = this.props;
    const itemMeta = this.props.getItemMeta(item);
    if (itemMeta.nestedTo) {
      const parentField = allFields.find((el) => el.name === itemMeta.nestedTo);
      return parentField?.label || '';
    }
    return '';
  };

  render() {
    const {
      intl,
      addCondition,
      removeCondition,
      getValues,
      availableFields,
      allFields,
      setProperty,
      getItemMeta,
      setProperties
    } = this.props;
    const { conditions } = this.state;
    return (
      <div name="Conditions" className="" data-qa="ticketProps">
        <div className="grid g15">
          {conditions.map((item, idx) => {
            if (item.name === 'site') {
              return null;
            }
            const itemMeta = getItemMeta(item);
            const selectedItem = availableFields.find(
              (el) => el.name === item.name
            );
            const type = this.getValueEditorType(itemMeta);
            const parentLabel = this.getParentLabel(item);
            const availableFieldsFiltered = availableFields.filter((el) => {
              return !conditions.some(
                (condition) =>
                  condition.id !== item.id && condition.name === el.name
              );
            });
            let selectedField = availableFields.find(
              (el) => el.name === item.name
            );
            let deletedField = false;

            if (!selectedField && item.name) {
              const isInactiveField = allFields.find(
                (el) => el.name === item.name
              );
              if (isInactiveField) {
                selectedField = allFields.find((el) => el.name === item.name);
                availableFieldsFiltered.push({
                  ...selectedField,
                  isInactive: true
                });
              } else {
                deletedField = true;
              }
            }

            return (
              <React.Fragment key={item.id}>
                <PropWrapper className="flex">
                  {/* <div className="flex g20 center p15 bg-bastel-blue">
                    <SVGIcon name="TicketOutline" />

                    <div className="mr-20">
                      <FormattedMessage id="admin.eventTrigger.actions.setProperty" />
                    </div>
                  </div> */}
                  <div className="pl10">
                    <ValueSelector
                      handleOnChange={setProperty.bind(this, 'name', item)}
                      placeholder={getTranslatedText(
                        intl,
                        'admin.eventTrigger.chooseProp'
                      )}
                      options={availableFields}
                      // TODO: Check here
                      optionsFiltered={availableFieldsFiltered}
                      title={getTranslatedText(
                        intl,
                        'admin.eventTrigger.chooseProp'
                      )}
                      value={selectedField?.name || ''}
                      className={`rule-fields`}
                      isOptionDisabled={(option) => option.isInactive}
                      errors={
                        deletedField
                          ? [`Field ${item.name} has been deleted`]
                          : null
                      }
                    />
                  </div>
                  <div className="ml8 mr8">
                    {' '}
                    <FormattedMessage id="admin.eventTrigger.to" />{' '}
                  </div>
                  <ValueEditor
                    field={itemMeta}
                    selectedItem={selectedItem}
                    fieldData={item.value}
                    operator="is"
                    value={item.value}
                    type={type}
                    values={(async function() {
                      const result = await getValues(item);
                      return result;
                    })()}
                    className={`rule-value`}
                    async
                    handleOnChange={(val) => {
                      if (item.name === 'client' || item.name === 'site') {
                        setProperties(val);
                      } else if (
                        item.name === 'techGroup' ||
                        item.name === 'technician'
                      ) {
                        setProperty('value', item, val);
                      } else {
                        let parsedVal = val;
                        if (Array.isArray(parsedVal)) {
                          parsedVal = val.map((el) => el.name);
                        } else if (typeof val === 'object') {
                          parsedVal = val.name;
                        }
                        setProperty('value', item, { value: parsedVal });
                      }
                    }}
                    isDisabled={
                      itemMeta.nestedTo &&
                      !this.state.conditions.find(
                        (condition) =>
                          condition.name === itemMeta.nestedTo &&
                          condition.value
                      )
                    }
                    parentLabel={parentLabel}
                    placeholder={getTranslatedText(
                      intl,
                      'admin.eventTrigger.value'
                    )}
                    allConditions={conditions}
                  />
                  <ActionElement
                    label=""
                    title={getTranslatedText(
                      intl,
                      'admin.eventTrigger.removeCondition'
                    )}
                    action="remove"
                    className="et-property-deletion mlauto pr-20"
                    handleOnClick={removeCondition.bind(this, idx)}
                  />
                </PropWrapper>
              </React.Fragment>
            );
          })}
        </div>
        <ActionGroupElement
          label={getTranslatedText(intl, 'admin.eventTrigger.property')}
          title={getTranslatedText(intl, 'admin.eventTrigger.addCondn')}
          action="add"
          className="et-property-addition mt10"
          handleOnClick={addCondition}
        />
      </div>
    );
  }
}

function TicketPropertiesCard(props) {
  const {
    allEntities,
    ticketAutomationMeta,
    type,
    intl,
    selectedRecords,
    filterCloseAndResolved = false
  } = props;
  const displayFields =
    ticketAutomationMeta.getTicketAutomationRuleMetaInfo.actionGroups[
      'PROPERTY_UPDATE'
    ];
  let parsedEntities = _.cloneDeep(allEntities);
  const context = props.context;
  const addIds = (arr) => {
    return arr.map((el) => {
      return {
        ...el,
        id: nanoid()
      };
    });
  };
  let propertyValue =
    context.value?.action?.find((el) => el.type === 'PROPERTY_UPDATE')?.data ||
    [];
  if (propertyValue && propertyValue.length) {
    propertyValue = addIds(propertyValue);
  }
  const [propertyConditions, setPropertyConditions] = useState(propertyValue);

  const preparedFieldsAttributes = getEntityAttributes(
    parsedEntities,
    ENTITY_MAP.ticket
  );
  let preparedFields = preparedFieldsAttributes.filter((item) => {
    return displayFields.some((el) => el === item.name);
  });
  const isDependant = (field) => {
    switch (field.name) {
      case 'client':
        return true;
      default:
        return field.isDependent;
    }
  };
  preparedFields = preparedFields.map((field) => {
    return {
      ...field,
      label: getTranslatedText(intl, field.label || field.name),
      isDependant: isDependant(field)
    };
  });
  const allFields = preparedFieldsAttributes.filter((field) => {
    return {
      ...field,
      label: getTranslatedText(intl, field.label || field.name),
      isDependant: isDependant(field)
    };
  });
  const updateConditions = (newConditions) => {
    setPropertyConditions(newConditions);
    if (props?.isRunBookAction && props.handleUpdateParent) {
      let customConditions = cloneDeep(newConditions);
      customConditions = customConditions.map((condition) => {
        if (condition?.customValue) {
          condition.value = condition.customValue;
        }
        return condition;
      });
      props.handleUpdateParent(customConditions);
    }

    let newConditionsForSave = newConditions.map((item) => {
      return { name: item.name, value: item.value };
    });
    let allActions = context.value?.action
      ? cloneDeep(context.value?.action)
      : [];
    let idx = allActions.findIndex((el) => el.type === 'PROPERTY_UPDATE');
    if (idx > -1) {
      allActions[idx] = {
        type: 'PROPERTY_UPDATE',
        data: newConditionsForSave
      };
    } else {
      allActions.push({
        type: 'PROPERTY_UPDATE',
        data: newConditionsForSave
      });
    }

    if (context?.updateAutomationRule) {
      context?.updateAutomationRule(allActions, 'action');
    }
  };

  const addCondition = () => {
    let newConditions = propertyConditions.concat([
      {
        name: '',
        value: '',
        id: `p-${nanoid()}`
      }
    ]);
    updateConditions(newConditions);
  };

  const findAllDescendants = (fieldName, descendants = []) => {
    const directChildren = preparedFields
      .filter((field) => field.nestedTo === fieldName)
      .map((field) => field.name);

    descendants.push(...directChildren);

    directChildren.forEach((childName) => {
      findAllDescendants(childName, descendants);
    });

    return descendants;
  };

  const GET_OTHER_DEPENDANTS_MAP = {
    client: ['site'] // name of the dependant field
  };
  const removeCondition = (idx) => {
    let newConditions = propertyConditions.slice();
    const conditionToRemove = newConditions[idx];

    newConditions.splice(idx, 1);

    const otherDependants = GET_OTHER_DEPENDANTS_MAP?.[conditionToRemove?.name];

    if (
      otherDependants &&
      Array.isArray(otherDependants) &&
      otherDependants?.length > 0
    ) {
      otherDependants.forEach((dependant) => {
        const otherDependantIndex = newConditions.findIndex(
          (condition) => condition?.name === dependant
        );
        if (otherDependantIndex > -1) {
          newConditions.splice(otherDependantIndex, 1);
        }
      });
    }

    // Clear technician value (not remove condition) when techGroup is removed
    if (conditionToRemove?.name === 'techGroup') {
      const technicianIdx = newConditions.findIndex(
        (condition) => condition.name === 'technician'
      );
      if (technicianIdx !== -1) {
        newConditions[technicianIdx].value = '';
        if (newConditions[technicianIdx].customValue) {
          delete newConditions[technicianIdx].customValue;
        }
      }
    }

    if (conditionToRemove && conditionToRemove.name) {
      const descendantFields = findAllDescendants(conditionToRemove.name);

      if (descendantFields.length > 0) {
        newConditions = newConditions.filter(
          (condition) => !descendantFields.includes(condition.name)
        );
      }
    }

    updateConditions(newConditions);
  };

  const getItemMeta = (item) => {
    return preparedFieldsAttributes.find((el) => el.name === item.name) || {};
  };

  function getPropValues(item) {
    const itemMeta = getItemMeta(item);
    if (item.name) {
      if (itemMeta.isCustom) {
        return AccountClient.query({
          query: GET_FIELD,
          variables: {
            input: {
              columnName: item?.columnName || item.name,
              module: ALL_MODULES.ticket
            }
          }
        });
      }

      const query = apiResolver.Ticket[item.name].api;
      let variables = apiResolver.Ticket[item.name]?.variables || {};
      const client = apiResolver.Ticket[item.name]?.client || TicketClient;

      if (item.name === 'techGroup' || item.name === 'technician') {
        variables = {
          input: {
            forOrganizations: selectedRecords.map((record) => ({
              ...(record?.client?.accountId && {
                accountId: record.client.accountId
              })
            }))
          }
        };

        variables.input.forOrganizations = variables.input.forOrganizations.filter(
          (org) => org && Object.keys(org).length > 0
        );
      }

      return client.query({
        query: query,
        variables
      });
    }
    return {};
    //return response;
  }

  async function getValues(item) {
    // TODO - change the below condition based on isDependant
    if (item.name === 'client') {
      return [];
    }

    const itemName = item?.name;

    const allValues = await getPropValues(item);
    let method = apiMethodAndKeyNames?.[itemName]?.method;
    const secondaryMethod = apiMethodAndKeyNames?.[itemName]?.secondaryMethod;
    const key = apiMethodAndKeyNames?.[itemName]?.key;
    const customKeys = apiMethodAndKeyNames?.[itemName]?.customKeys;
    let res = [];

    let dataToMap = [];
    if (secondaryMethod) {
      dataToMap = allValues.data[method]?.[secondaryMethod];
    } else if (method) {
      dataToMap = allValues.data[method];
    }

    const itemMeta = getItemMeta(item);
    if (item.nestedTo) {
      const nestedProp = apiMethodAndKeyNames?.[itemName]?.nestedKey;
      if (!nestedProp) {
        res = dataToMap?.map((c) => ({
          name: c[key],
          value: c[key],
          label: c[key]
        }));
      } else {
        res =
          dataToMap?.[nestedProp] &&
          dataToMap?.[nestedProp].map((el) => {
            return {
              name: el[key],
              value: el[key],
              label: el[key]
            };
          });
      }
    }
    if (itemMeta.isCustom || itemMeta.nestedTo) {
      method = 'getField';
      let parentLabel = itemMeta.nestedTo;
      if (parentLabel) {
        const parentCondition = propertyConditions.find(
          (condition) => condition.name === parentLabel
        );

        if (parentCondition && parentCondition.value) {
          let options = allValues?.data?.[method]?.options || [];

          options = options.filter(
            (option) =>
              option.parentOption &&
              option.parentOption.value === parentCondition.value
          );

          res = options.map((el) => {
            return {
              name: el?.value,
              value: el?.value,
              label: el?.value
            };
          });

          return res;
        }
      }

      const fldOptions =
        allValues?.data?.[method]?.options ||
        allValues?.data?.[method]?.fieldOptions;
      res = allValues.data
        ? fldOptions?.map((el) => {
            return {
              name: el?.value,
              value: el?.value,
              label: el?.value
            };
          })
        : [];
    } else {
      if (item?.name === 'status' && filterCloseAndResolved) {
        dataToMap = dataToMap.filter(
          (item) =>
            !(
              item?.details?.constants &&
              /close|resolve/i.test(item.details.constants)
            )
        );
      }
      if (item?.name === 'technician') {
        // special hadling to list technicians based on technician group.
        let techGroupCondition = propertyConditions.find(
          (condition) => condition.name === 'techGroup' && condition.value
        );
        const groupId =
          techGroupCondition && techGroupCondition?.customValue?.groupId;

        let userList = dataToMap.flatMap((item) => item.userList);

        if (groupId) {
          const filteredData = dataToMap.filter(
            (item) => item.groupId === groupId
          );
          userList = filteredData ? filteredData[0].userList : [];
        }
        userList = userList.map((el) => ({
          ...el,
          name: `${el?.firstName} ${el?.lastName}`
        }));

        dataToMap = userList;
      }
      res = dataToMap
        ? dataToMap.map((el) => {
            return {
              name: el[key],
              value: el[key],
              label: el[key],
              ...(customKeys && customKeys.length > 0
                ? customKeys.reduce((acc, curr) => {
                    acc[curr] = el[curr];
                    return acc;
                  }, {})
                : {})
            };
          })
        : [];
    }
    return res;
  }

  // function getValues(item){
  //   console.log('calling valuess')
  //   if(item.name){
  //     let selectedProp = preparedFields.find(el => el.name === item.name);
  //     let allValues = [];

  //     let values = [];
  //     if(values && values[0]?.name){
  //       values = values.map(el => {
  // return{
  //   name: el.name,
  //   value: el.name,
  //   label: el.name
  // }
  //       })
  //     }
  //     else{//TODO - vignesh n level
  //       values = values.map(el => {
  //         return{
  //           name: el,
  //           value: el,
  //           label: el
  //         }
  //       })
  //     }
  //     return values;
  //   }
  //   return [];

  // }

  const getParentFieldsRecursively = (field, newConditions) => {
    let parentConditions = [];

    if (field.nestedTo) {
      const parentExists = newConditions.some(
        (condition) => condition.name === field.nestedTo
      );
      if (!parentExists) {
        const parentCondition = {
          name: field.nestedTo,
          value: '',
          id: `p-${nanoid()}`
        };

        parentConditions.push(parentCondition);
      }

      const parentField = preparedFields.find((f) => f.name === field.nestedTo);
      if (parentField && parentField.nestedTo) {
        const grandParentConditions = getParentFieldsRecursively(
          parentField,
          newConditions
        );
        parentConditions = [...grandParentConditions, ...parentConditions];
      }
    }

    return parentConditions;
  };

  const setProperty = (prop, el, item) => {
    let newConditions = _.cloneDeep(propertyConditions);
    const idx = newConditions.findIndex((r) => r.name === el.name);

    if (idx > -1) {
      const oldValue = newConditions[idx].value;
      const oldName = newConditions[idx].name;

      // When a field name changes, remove descendants
      if (prop === 'name' && oldName !== item[prop]) {
        newConditions[idx].value = '';

        const descendantFields = findAllDescendants(oldName);

        if (descendantFields.length > 0) {
          newConditions = newConditions.filter(
            (condition) => !descendantFields.includes(condition.name)
          );
        }
      }

      newConditions[idx] = {
        ...newConditions[idx],
        [prop]: item[prop]
      };

      const fieldConfig = apiMethodAndKeyNames?.[el?.name];
      if (fieldConfig?.customKeys?.length > 0) {
        const customValue = fieldConfig.customKeys.reduce((acc, key) => {
          if (item[key] !== undefined) {
            acc[key] = item[key];
          }
          return acc;
        }, {});

        if (Object.keys(customValue).length > 0) {
          newConditions[idx].customValue = customValue;
        }
      }

      // When a field's value changes, reset all its descendants values
      if (prop === 'value' && oldValue !== item[prop]) {
        const descendantFields = findAllDescendants(el.name);

        if (descendantFields.length > 0) {
          // Reset values for all descendants
          descendantFields.forEach((descendantName) => {
            const descendantIdx = newConditions.findIndex(
              (condition) => condition.name === descendantName
            );

            if (descendantIdx !== -1) {
              newConditions[descendantIdx].value = '';
            }
          });
        }

        // Clear technician when techGroup value changes
        if (el.name === 'techGroup') {
          const technicianIdx = newConditions.findIndex(
            (condition) => condition.name === 'technician'
          );
          if (technicianIdx !== -1) {
            newConditions[technicianIdx].value = '';
            if (newConditions[technicianIdx].customValue) {
              delete newConditions[technicianIdx].customValue;
            }
          }
        }
      }
    }

    if (item.nestedTo) {
      const parentConditions = getParentFieldsRecursively(item, newConditions);

      if (parentConditions.length > 0) {
        const childIndex = newConditions.findIndex(
          (condition) => condition.name === item.name
        );

        if (childIndex !== -1) {
          const childItem = newConditions.splice(childIndex, 1)[0];
          newConditions.splice(childIndex, 0, ...parentConditions);
          newConditions.splice(
            childIndex + parentConditions.length,
            0,
            childItem
          );
        } else {
          newConditions = [...newConditions, ...parentConditions];
        }
      }
    }

    updateConditions(newConditions);
  };

  const setProperties = (obj) => {
    const properties = obj.properties;
    let newConditions = _.cloneDeep(propertyConditions);
    Object.keys(properties)?.forEach((el) => {
      const idx = newConditions.findIndex((r) => r.name === el);
      if (idx > -1) {
        newConditions[idx] = {
          ...newConditions[idx],
          value: properties[el].id
            ? { id: properties[el].id }
            : { accountId: properties[el].accountId }
        };
      } else {
        newConditions.push({
          name: el,
          value: properties[el].id
            ? { id: properties[el].id }
            : { accountId: properties[el].accountId }
        });
      }
    });
    updateConditions(newConditions);
  };

  useEffect(() => {
    if (props?.isRunBookAction) {
      if (
        !propertyConditions ||
        (Array.isArray(propertyConditions) && !propertyConditions.length)
      ) {
        addCondition();
      }
    }
  }, []);

  return (
    <>
      <PropertySelection
        intl={intl}
        allFields={allFields}
        getValues={getValues}
        setProperty={setProperty}
        getItemMeta={getItemMeta}
        addCondition={addCondition}
        setProperties={setProperties}
        availableFields={preparedFields}
        removeCondition={removeCondition}
        propertyConditions={propertyConditions}
      />
      {/* {type == 'time' &&
        <NotificationMessage/>
      } */}
    </>
  );
}

const PropWrapper = styled.div`
  align-items: center;
  // padding: 10px 15px;
  border-radius: 4px;
  border: 1px solid #ececec;
  .value_selector__control {
    border-bottom: 0 !important;
  }
  &:hover {
    background-color: #f5f5fc !important;
  }
`;

export default injectIntl(TicketPropertiesCard);
